import * as ActionUtility from "../../utilities/ActionUtility";
import ApiKeyModel from '../models/ApiKeyModel';
import IStore from '../../models/IStore';

import HttpErrorResponseModel from '../../models/HttpErrorResponseModel';
import { ReduxDispatch } from '../../models/ReduxProps';
import ApiKeyEffect from "../effects/apiKeysEffect";
import ApiKeyListModel from "../models/ApiKeyListModel";

type ActionUnion =
  void
  | HttpErrorResponseModel
  | ApiKeyModel
  | String;

export default class ApiKeyActions{
  public static readonly  REQUEST_GET_API_KEY_LIST = 'ApiKeyActions.REQUEST_GET_API_KEY_LIST';
  public static readonly  REQUEST_GET_API_KEY_LIST_FINISHED = 'ApiKeyActions.REQUEST_GET_API_KEY_LIST_FINISHED';

  public static readonly  REQUEST_POST_API_KEY = 'ApiKeyActions.REQUEST_POST_API_KEY';
  public static readonly  REQUEST_POST_API_KEY_FINISHED = 'ApiKeyActions.REQUEST_POST_API_KEY_FINISHED';

  public static readonly  REQUEST_DELETE_API_KEY = 'ApiKeyActions.REQUEST_DELETE_API_KEY';
  public static readonly  REQUEST_DELETE_API_KEY_FINISHED = 'ApiKeyActions.REQUEST_DELETE_API_KEY_FINISHED';

   public static getApiKeyList ():any {
    return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore) => {
      await ActionUtility.createThunkEffect<ApiKeyListModel>(
        dispatch,
        getState(),
        ApiKeyActions.REQUEST_GET_API_KEY_LIST,
        ApiKeyEffect.getApiKeyList,
      );
    };
  };

  public static createApiKey = () : any => {
    return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore) => {
      return ActionUtility.createThunkEffect(
        dispatch,
        getState(),
        ApiKeyActions.REQUEST_POST_API_KEY,
        ApiKeyEffect.createApiKey,
      );
    };
  };

   public static deleteApiKey = (keyId: string) : any => {
    return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore) => {
      return ActionUtility.createThunkEffect(
        dispatch,
        getState(),
        ApiKeyActions.REQUEST_DELETE_API_KEY,
        ApiKeyEffect.deleteApiKey,
        keyId
      );
    };
  };
}


